import {useLocale} from "next-intl";
import {useEffect} from "react";

declare global {
    interface Window {
        // Defined by the Zendesk snippet that `ZEInitializer` loads `afterInteractive`,
        // so it is absent until that script runs — and forever if it is blocked.
        zE?: (...args: unknown[]) => void;
    }
}

export const useZendeskWidget = () => {
    const locale = useLocale();

    const onOpenWidget = () => {
        // AC-927: a tap before the snippet has loaded must not throw.
        if (typeof window.zE !== "function") return;

        window.zE("messenger:set", "locale", locale);
        window.zE("messenger", "open");
    }

    useEffect(() => {
        if (typeof window.zE === "function") {
            window.zE("messenger:set", "locale", locale);
        }
    }, [locale])

    return {
        onOpenWidget,
    }
};
